import moment from "moment-timezone";
export const getTime = (v: number): any => {
  return moment.unix(v).tz("Europe/Stockholm").format("YYYY-MM-DD");
};
export const getTime2 = (v: number): any => {
  return moment.unix(v).tz("Europe/Stockholm");
};
export const getCurrentTime2 = (): any => {
  return moment.tz("Europe/Stockholm");
};
export const getCurrentTime = (): any => {
  return moment.tz("Europe/Stockholm").format("YYYY-MM-DD");
};
export const getTimeInUnixTime = (v: number): any => {
  return moment.unix(v).tz("Europe/Stockholm").format("X");
};
export const getCurrentUnixTime = (): any => {
  return moment.tz("Europe/Stockholm").unix();
};
export const getYesterday = (): any => {
  return moment.tz("Europe/Stockholm").subtract(1, "days");
};
export const getYesterdayYYMMDD = (): any => {
  return moment.tz("Europe/Stockholm").subtract(1, "days").format("YYYY-MM-DD");
};
export const getUnixTime = (v: string): any => {
  let x = v + " 23:59:59";
  return moment.tz(x, "Europe/Stockholm").format("X");
};
export const getThirtyOneDaysFromNowInUnixTime = (): any => {
  return moment.tz("Europe/Stockholm").add(31, "days").unix();
};
